import { stringify } from "qs";
import { JobListPresenter } from "../../../components/other-web/supplier/presenters/JobListPresenter";
import { JobDetailPresenter } from "../../../components/other-web/supplier/presenters/JobDetailPresenter";
import { SubscriberPresenter } from "../../../components/other-web/supplier/presenters/SubscriberPresenter";
import { InvoiceListPresenter } from "../../../components/other-web/supplier/presenters/InvoiceListPresenter ";
import { AppointmentFulfilledListPresenter } from "../../../components/other-web/supplier/presenters/AppointmentFulfilledListPresenter";
import { InvoiceDetailPresenter } from "../../../components/other-web/supplier/presenters/InvoiceDetailPresenter";
import { InvoiceDetailProjectAppointmentListPresenter } from "../../../components/other-web/supplier/presenters/InvoiceDetailProjectAppointmentListPresenter";
import { InvoiceDetailRejectedReasonListPresenter } from "../../../components/other-web/supplier/presenters/InvoiceDetailRejectedReasonListPresenter";

export class SupplierClient {
  /**
   * @param {import('./HTTPClient').HTTPClient} httpClient
   * @param {string} adminURL
   * @param {string} subscriptionURL
   * @param {string} appointmentURL
   */
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.partnerUrl = `${baseURL}/partner`;
    this.adminURL = `${baseURL}/admin`;
    this.subscriptionURL = `${this.adminURL}/subscriptions`;
    this.appointmentURL = `${this.subscriptionURL}/appointments`;
  }

  async login(params) {
    const url = `${this.adminURL}/auth/login`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response.data;
  }

  async auth() {
    const url = `${this.adminURL}/auth`;

    const response = await this.httpClient.request("get", url);

    return response.data;
  }

  async getUsers(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.adminURL}/users${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async getProjectsByAppointmentStatus(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.partnerUrl}/projects${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async getReportProjects() {

    const url = `${this.partnerUrl}/projects`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async getProjectsByInvoiceStatus(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.partnerUrl}/invoice/list/projects${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async getCreateInvoiceProjects() {
    const url = `${this.partnerUrl}/invoice/create/projects`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async getHomes(id) {
    const url = `${this.adminURL.replace(
      "/api",
      ""
    )}/member-management/projects/${id}/homes`;

    const response = await this.httpClient.request("get", url);

    return response.data;
  }

  async getProviderProfile(id) {
    const url = `${this.subscriptionURL}/providers/${id}`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async getSubscriberDetail(id) {
    const url = `${this.subscriptionURL}/subscribers/${id}`;

    const response = await this.httpClient.request("get", url);

    const subscriberDetail = response.data.result;

    return new SubscriberPresenter(subscriberDetail);
  }

  async getAppointments(subscriptionMemberId, params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.subscriptionURL}/subscribers/${subscriptionMemberId}/appointments${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async appoint(id, params) {
    const url = `${this.appointmentURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async getProviderAppointmentList(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.appointmentURL}${queryString}`;

    const response = await this.httpClient.request("get", url);

    const { appointments, count } = response.data.result;

    return new JobListPresenter(count, appointments);
  }

  async getProviderReportList(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.appointmentURL}/provider/reports${queryString}`;
    const config = params && params.format === "xlsx"
    ? { responseType: "blob" }
    : undefined;

    const response = await this.httpClient.request(
      "get",
      url,
      config
    );

    if (params.format === "xlsx") {
      return response.data;
    } 
      const { appointments, count } = response.data.result;
      return new JobListPresenter(count, appointments);
    
  }

  async getProviderAppointmentDetail(id) {
    const url = `${this.appointmentURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    const appointment = response.data.result;

    return new JobDetailPresenter(appointment);
  }

  async updateAppointment(id, params) {
    const url = `${this.appointmentURL}/${id}/date`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async updateAppointmentStatus(id, params) {
    const url = `${this.appointmentURL}/${id}/update`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async getAppointmentNotices(id) {
    const url = `${this.appointmentURL}/notices/${id}`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async createNote(params) {
    const url = `${this.appointmentURL}/create/action_note`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async getInvoiceDashboard() {
    const url = `${this.partnerUrl}/invoice/dashboard`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async getInvoiceList(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.partnerUrl}/invoice/list${queryString}`;

    const response = await this.httpClient.request("get", url);

    const { invoices, count } = response.data.result;
    
    return new InvoiceListPresenter(invoices, count);
  }

  async getAppointmentFulfilledList(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.partnerUrl}/invoice/appointment_fulfilled${queryString}`;

    const response = await this.httpClient.request("get", url);
    
    return new AppointmentFulfilledListPresenter(response.data.result);
  }

  async getProjectAppointmentListByInvoiceId(id) {
    const url = `${this.partnerUrl}/invoice/${id}/appointment`;

    const response = await this.httpClient.request("get", url);
    
    return new InvoiceDetailProjectAppointmentListPresenter(response.data.result);
  }

  async createInvoice(params) {
    const url = `${this.partnerUrl}/invoice/create`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });
    
    return response.data.result;
  }

  async getInvoiceDetails(id) {
    const url = `${this.partnerUrl}/invoice/${id}`;

    const response = await this.httpClient.request("get", url);
    
    return new InvoiceDetailPresenter(response.data.result);
  }

  async deleteInvoice(id) {
    const url = `${this.partnerUrl}/invoice/${id}`;

    const response = await this.httpClient.request("delete", url);
    
    return response.data.message;
  }

  async getRuejaiPartnerAdminInvoiceList(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.partnerUrl}/invoice/admin/list${queryString}`;

    const response = await this.httpClient.request("get", url);

    const { invoices, count } = response.data.result;
    
    return new InvoiceListPresenter(invoices, count);
  }

  async getRuejaiPartnerAdminProjectsByInvoiceStatus(params) {
    const queryString = stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.partnerUrl}/invoice/admin/list/projects${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async getRuejaiPartnerAdminRejectedReasonList() {
    const url = `${this.partnerUrl}/invoice/admin/reject_reasons`;

    const response = await this.httpClient.request("get", url);
    
    return new InvoiceDetailRejectedReasonListPresenter(response.data.result);
  }

  async updateInvoiceStatus(id, params) {
    const url = `${this.partnerUrl}/invoice/status_update/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response.data.result;
  }
}
